import {
  DASHBOARD_LOOK_UP,
  EID_FORM_LIST,
  FACILITY_LOOK_UP,
  FETCH_APPROVE_TEST_CONFIGURATION,
  FETCH_END,
  FETCH_ENTER_TEST_CONFIGURATION,
  FETCH_ERROR,
  FETCH_GENERAL_TEST_CONFIGURATION,
  FETCH_GO_TEST_CONFIGURATION,
  FETCH_INSTRUMENT,
  FETCH_LAB_SECTION,
  FETCH_LOCAL_GOVERNMENT_AREA_LIST,
  FETCH_METHOD,
  FETCH_OCCUPATION_LIST,
  FETCH_PROGRAM_LIST,
  FETCH_REJECTION_REASON,
  FETCH_RESULT_REJECTION_REASON,
  FETCH_START,
  FETCH_STATE_LIST,
  FETCH_SUCCESS,
  FETCH_TB_TEST_CONFIGURATION,
  FETCH_TEST_CONFIGURATION,
  FETCH_TEST_STATUS_CONFIGURATION,
  FETCH_TEST_TYPE,
  FETCH_WORKSHEET_LIST,
  GENERAL_ORDER_LOOK_UP,
  HIDE_MESSAGE,
  OPERATION_SUCCESSFUL,
  PH_TEST_SAMPLES_LOOK_UP,
  SAMPLE_COLLECTION_LOOKUP_LIST,
  SERVICE_TEST_TAT_LIST,
  SET_BENCH,
  SET_FILTER_TYPE,
  SET_PROGRAM,
  SET_ROLES,
  SET_SAMPLE_TYPE,
  SHOW_MESSAGE,
  TB_FORM_LIST,
  TEST_CONFIG_LOOK_UP,
  UPDATE_LGA,
  UPDATE_PROGRAM,
  UPDATE_STATE,
  USER_LOCATION_LOOK_UP,
  VL_FORM_LIST,
  PH_PROTOCOLS,
  PH_STAGES,
} from "constants/ActionTypes";
import { httpClient } from "utils/Api";
import { QueryKeysEnums } from "utils/Constant";
import { queryClient } from "utils/queryClient";
import { getSessionStorage, setSessionStorage } from "utils/Storage";

//For setting Filter type
export const setFilterType = (filterType) => {
  return {
    type: SET_FILTER_TYPE,
    payload: filterType,
  };
};

export const setCurrentPrograms = (program) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROGRAM,
      payload: program,
    });
  };
};

export const setCurrentState = (states) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_STATE,
      payload: states,
    });
  };
};

export const setCurrentLga = (lga) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_LGA,
      payload: lga,
    });
  };
};

export const fetchSuccess = (message) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SUCCESS,
      payload: message || "",
    });
  };
};
export const fetchError = (error) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_ERROR,
      payload: error,
    });
  };
};

export const fetchStart = () => {
  return (dispatch) => {
    dispatch({
      type: FETCH_START,
    });
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const setProgram = (params) => {
  return {
    type: SET_PROGRAM,
    payload: params,
  };
};

//for getting State list
export const fetchTBFormList = (params) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("/tb_form_lookup/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: TB_FORM_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

//for getting State list
export const fetchEIDFormList = (params) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("/eid_form_lookup/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: EID_FORM_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

export const fetchVLFormList = (params) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("/viral_load_form_lookup/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: VL_FORM_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

// for getting State list
export const fetchStateList = (params) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("/state/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: FETCH_STATE_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

//for getting State list
// export const fetchLocalGovernmentAreaList = (params) => {
//   let _params = params ? `/local_government_area/?state=${params}`:`/local_government_area/`

//   return async (dispatch) => {
//     dispatch(fetchStart());
//     await httpClient
//       .get(_params)
//       .then((res) => {
//         if (res.status === 200) {
//           dispatch(fetchSuccess());
//           dispatch({
//             type: FETCH_LOCAL_GOVERNMENT_AREA_LIST,
//             payload: res.data,
//           });
//         } else {
//           dispatch(fetchError(res.error));
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchError(error[1]?.message));
//       });
//   };
// };
export const fetchLocalGovernmentAreaList = (params) => {
  let _params = params
    ? `/local_government_area/?state=${params}`
    : "/local_government_area/";

  return async (dispatch) => {
    try {
      dispatch(fetchStart());
      const res = await httpClient.get(_params);
      dispatch(fetchSuccess());
      dispatch({
        type: FETCH_LOCAL_GOVERNMENT_AREA_LIST,
        payload: res.data,
      });
    } catch (error) {
      dispatch(fetchError(error[1]?.message));
    }
  };
};

// get Role list
export const fetchRoleList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("roles/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: SET_ROLES, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get department list
export const fetchSectionList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("lab_section/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_LAB_SECTION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get Role list
export const fetchSampleCollectionLookUpList = () => {
  const _checkForLocalData = getSessionStorage(SAMPLE_COLLECTION_LOOKUP_LIST);
  const _foundLocalData = _checkForLocalData
    ? JSON.parse(_checkForLocalData)
    : [];
  const _dataAvailable = _foundLocalData?.programList?.length > 0;

  return async (dispatch) => {
    dispatch(fetchStart());

    if (_dataAvailable) {
      dispatch({
        type: SAMPLE_COLLECTION_LOOKUP_LIST,
        payload: _foundLocalData,
      });
    } else {
      await httpClient
        .get("collection_look_up/")
        .then((res) => {
          setSessionStorage(
            SAMPLE_COLLECTION_LOOKUP_LIST,
            JSON.stringify(res.data)
          );
          dispatch({ type: SAMPLE_COLLECTION_LOOKUP_LIST, payload: res.data });
          dispatch(fetchSuccess());
        })
        .catch((error) => {
          dispatch(fetchError(error[1]?.message));
          throw error;
        });
    }
  };
};

//for getting Program list
export const fetchProgramList = (params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpClient
      .get("/program/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: FETCH_PROGRAM_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

//for getting Program list
export const fetchOccupationList = (params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpClient
      .get("/occupation/", { params })
      .then((data) => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: FETCH_OCCUPATION_LIST, payload: data.data });
        } else {
          dispatch(fetchError(data.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
      });
  };
};

// get Bench list
export const fetchBenchList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("bench/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: SET_BENCH, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};
export const fetchResultRejectionReasonList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("result_rejection_reason/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_RESULT_REJECTION_REASON, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get rejection reason list
export const fetchRejectionReasonList = () => {
  const _checkForLocalData = getSessionStorage(FETCH_REJECTION_REASON);
  const _foundLocalData = _checkForLocalData
    ? JSON.parse(_checkForLocalData)
    : [];
  const _dataAvailable = _foundLocalData?.length > 0;

  return async (dispatch) => {
    dispatch(fetchStart());
    if (_dataAvailable) {
      dispatch({
        type: FETCH_REJECTION_REASON,
        payload: _foundLocalData,
      });
      dispatch(fetchEnd());
    } else {
      await httpClient
        .get("rejection_reason/")
        .then((res) => {
          setSessionStorage(FETCH_REJECTION_REASON, JSON.stringify(res.data));
          dispatch({ type: FETCH_REJECTION_REASON, payload: res.data });
          dispatch(fetchSuccess());
        })
        .catch((error) => {
          dispatch(fetchError(error[1]?.message));
          throw error;
        })
        .finally(() => {
          dispatch(fetchEnd());
        });
    }
  };
};

// get Bench list
export const fetchSampleType = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("sample_type/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: SET_SAMPLE_TYPE, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get method list
export const fetchMethod = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("method/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_METHOD, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchTestConfiguration = (program, test_type) => {
  // create query params, that handles if programs and test_type is null

  const _params =
    program && test_type
      ? `?program__name=${program}&test_type=${test_type}`
      : program
      ? `?program__name=${program}`
      : test_type
      ? `?test_type=${test_type}`
      : "";

  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`test_configuration/${_params}`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};
// get test configuration list
export const fetchGOTestConfiguration = (program) => {
  const _checkForLocalData = getSessionStorage(FETCH_GO_TEST_CONFIGURATION);
  const _foundLocalData = _checkForLocalData
    ? JSON.parse(_checkForLocalData)
    : [];
  const _dataAvailable = _foundLocalData?.length > 0;

  return async (dispatch) => {
    dispatch(fetchStart());
    // Show the cached copy at once, then refresh it: a facility can change its units
    // and ranges while another user's session is open.
    if (_dataAvailable) {
      dispatch({
        type: FETCH_GO_TEST_CONFIGURATION,
        payload: _foundLocalData,
      });
    }
    await httpClient
      .get(
        program
          ? `test_configuration/?program__name=${program}`
          : `test_configuration/`
      )
      .then((res) => {
        setSessionStorage(
          FETCH_GO_TEST_CONFIGURATION,
          JSON.stringify(res.data)
        );
        dispatch({ type: FETCH_GO_TEST_CONFIGURATION, payload: res.data });
        dispatch(fetchSuccess());
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        // The cached copy is already on screen: a failed refresh need not stop the page.
        if (!_dataAvailable) throw error;
      })
      .finally(() => {
        dispatch(fetchEnd());
      });
  };
};

// get all test configuration list
export const fetchAllTestConfiguration = (test_types = null) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(
        test_types
          ? `facility_test_measure/effective?test_types=${test_types}`
          : `test_configuration/?scope=global` // the global settings page
      )
      .then((res) => {
        dispatch(fetchSuccess());
        // console.log(res)
        // res?.data?.sort((a, b) => {
        //   return a.test_type_name.localeCompare(b.test_type_name);
        // });
        dispatch({ type: FETCH_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchGeneralTestConfiguration = (test_type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(
        test_type
          ? `test_configuration/?test_type=${test_type}`
          : `test_configuration/`
      )
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_GENERAL_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchTBTestConfiguration = (program, test_type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(
        test_type && program
          ? `test_configuration/?test_type=${test_type}&program__name=${program}`
          : `test_configuration/`
      )
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_TB_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchTestStatusCount = (param) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`${param}`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_TEST_STATUS_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchTestTypePHConfiguration = (program, test_type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(
        test_type && program
          ? `test_configuration/?test_type=${test_type}&program__name=${program}`
          : `test_configuration/?program__name=${program}`
      )
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_ENTER_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test configuration list
export const fetchApproveTestPHConfiguration = (program, test_type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(
        test_type && program
          ? `test_configuration/?test_type=${test_type}&program__name=${program}`
          : `test_configuration/?program__name=${program}`
      )
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_APPROVE_TEST_CONFIGURATION, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get Instrument list
export const fetchInstrument = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("instrument/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_INSTRUMENT, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get test type list
export const fetchTestType = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("test_type/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_TEST_TYPE, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// Post sample status used for update
export const postSampleStatus = ({ formData, form }) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    await httpClient
      .post(`/${form}/`, formData)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch(fetchSuccess(OPERATION_SUCCESSFUL));
          queryClient.invalidateQueries([QueryKeysEnums.TEST_STATUS_COUNT]);
        } else {
          dispatch(fetchError(res.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      })
      .finally(() => {
        dispatch(fetchEnd());
      });
  };
};

// Patch sample status
export const patchSampleStatus = ({ id, formData, form }) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .patch(`/${form}/${id}/`, formData)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          dispatch(fetchSuccess(OPERATION_SUCCESSFUL));
          queryClient.invalidateQueries([QueryKeysEnums.TEST_STATUS_COUNT]);
        } else {
          dispatch(fetchError(res.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      })
      .finally(() => {
        dispatch(fetchEnd());
      });
  };
};

export const fetchFacilityLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("facility_look_up/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FACILITY_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

export const fetchTestConfigLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("test_configuration_look_up/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: TEST_CONFIG_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

export const fetchGeneralOrderLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("general_order_look_up/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: GENERAL_ORDER_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};
// get Bench list
export const fetchLocationUserLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("user_location_look_up/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: USER_LOCATION_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get dashboard filter list
export const fetchDashboardLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get("dashboard_filter/")
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: DASHBOARD_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// get Bench list
export const fetchPHTestSampleLookUpList = (param) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`public_health_test_samples_look_up/?program__name=${param}`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: PH_TEST_SAMPLES_LOOK_UP, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
}; // get TAT list


export const fetchProtocolList = (param) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`program_protocol/?program__name=${param}`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: PH_PROTOCOLS, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
}; 

export const fetchStageList = (param) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`program_stage/?program__name=${param}`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: PH_STAGES, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
}; 




export const fetchServiceTestTATLookUpList = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`facility_program_tat/`)
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: SERVICE_TEST_TAT_LIST, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};

// =====New Api Request

/**
 * @function getState
 * @param arg
 * @return object
 */
export const getState = (arg = "") => {
  const params = arg !== "" ? `state/${arg}/` : "state/";

  return async (dispatch) => {
    try {
      dispatch(fetchStart());
      const { data } = await httpClient.get(params);
      dispatch(fetchSuccess());
      return data;
    } catch (error) {
      dispatch(fetchError(error[1]?.message));
      throw error;
    }
  };
};

/**
 * @function getLga
 * @param arg
 * @return object
 */
export const getLga = (arg) => {
  return async (dispatch) => {
    try {
      dispatch(fetchStart());
      const { data } = await httpClient.get(`local_government_area/${arg}/`);
      dispatch(fetchSuccess());
      return data;
    } catch (error) {
      dispatch(fetchError(error[1]?.message));
      throw error;
    }
  };
};

export const saveWorksheet = (formData) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    
    const isUpdate = formData.is_update || formData.id;
    const url = isUpdate ? `worksheet/${formData.id}/` : 'worksheet/';
    const method = isUpdate ? 'put' : 'post';
    
    await httpClient[method](url, formData)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch(fetchSuccess(OPERATION_SUCCESSFUL));
        } else {
          dispatch(fetchError(res.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      })
      .finally(() => {
        dispatch(fetchEnd());
      });
  };
};

/**
 * @function getWorkSheet
 * @description save worksheet
 */

export const getWorkSheet = (test_type) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    await httpClient
      .get(`worksheet/`, {
        params: {
          ...(test_type && { test_type }),
        },
      })
      .then((res) => {
        dispatch(fetchSuccess());
        dispatch({ type: FETCH_WORKSHEET_LIST, payload: res.data });
      })
      .catch((error) => {
        dispatch(fetchError(error[1]?.message));
        throw error;
      });
  };
};
